export default __webpack_public_path__ + "static/banner1-64cbb477f696e9763d95519dc390364e.jpg";